import styled from "styled-components";

export const RegisterFormStyled = styled.div`
  .login_header {
    margin-bottom: 40px;
    text-align: center;
    color: ${({ theme }) => theme.COLORS.PURPLE_11};
    font-size: ${({ theme }) => theme.FONT.SIZE.S18};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
  }
  .input_wrap {
    margin-bottom: 15px;
    &.mb_12 {
      margin-bottom: 12px;
    }
    &.mb_82 {
      margin-bottom: 82px;
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.MOBILE}) {
    .login_header {
      font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
    }
  }
`;
